import React from 'react';

interface FaceOffSectionProps {
  onUsFaceOff: () => void;
  onThemFaceOff: () => void;
}

const FaceOffSection: React.FC<FaceOffSectionProps> = ({ onUsFaceOff, onThemFaceOff }) => (
  <div>
    <div className="relative text-2xl font-bold text-center z-10">Face-off Won</div>
    <div className="relative flex w-full justify-between items-stretch gap-4 z-10 py-3 px-3 h-[80x]">
      <div className="flex-1 flex justify-center">
        <div
          className="w-full font-bold rounded-lg px-3 xs:px-6 py-4 text-center flex justify-center items-center shadow-lg cursor-pointer bg-[#7fe526] text-black"
          onClick={onUsFaceOff}
        >
          <div className="text-xl sm:text-2xl">US</div>
        </div>
      </div>
      <div className="flex-1 flex justify-center">
        <div
          className="w-full font-bold rounded-lg px-3 xs:px-6 py-4 text-center flex justify-center items-center shadow-lg cursor-pointer bg-[#294e87] text-white"
          onClick={onThemFaceOff}
        >
          <div className="text-xl sm:text-2xl">THEM</div>
        </div>
      </div>
    </div>
  </div>
);

export default FaceOffSection;
